import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountData } from '../account.model';
import { AccountService } from '../account.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-account-app-bar-title',
    templateUrl: './account-app-bar-title.component.html',
    styleUrls: ['./account-app-bar-title.component.scss'],
    standalone: false
})
export class AccountAppBarTitleComponent implements OnInit {

  title: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService) { }

  accountListNavigate() {
    this.router.navigateByUrl(this.accountService.prevAccountListUrl || '/account');
  }

  data: AccountAppBarTitleComponentData;

  dataSet(data: AccountAppBarTitleComponentData) {
    this.data = data;
    this.title = data.account ? `${data.account.loanNumber} - ${data.account.entityName}; ${data.account.entityNumber}` : '';
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataSet.bind(this));
  }

}

export interface AccountAppBarTitleComponentData {
  account: AccountData;
}
